import { useState, useEffect } from 'react'
import firebase from '../firebase/compat'
import { client } from './Client'

// De details-callable is een volledige tenant-scan; de payload bevat álle
// vier de dimensies. Wie van dimensiepagina naar dimensiepagina klikt zou
// zonder memo per pagina opnieuw scannen — één korte memo per tenant laat
// het bladeren op één scan draaien, terwijl een refresh ná een opschoonactie
// (>2 min later, of harde reload) gewoon verse data geeft.
const DETAILS_TTL_MS = 2 * 60 * 1000
/** @type {{ client: string | null, at: number, promise: Promise<object> | null }} */
let detailsMemo = { client: null, at: 0, promise: null }

const fetchDetails = () => {
    const fresh = detailsMemo.promise
        && detailsMemo.client === client
        && Date.now() - detailsMemo.at < DETAILS_TTL_MS
    if (fresh) return detailsMemo.promise

    const getDataQualityDetails = firebase
        .app()
        .functions('europe-west1')
        .httpsCallable('getDataQualityDetails')

    const promise = getDataQualityDetails({ client }).then((result) => result.data)
    detailsMemo = { client, at: Date.now(), promise }
    // Mislukte call nooit 2 minuten vasthouden — volgende mount probeert opnieuw
    promise.catch(() => { if (detailsMemo.promise === promise) detailsMemo = { client: null, at: 0, promise: null } })
    return promise
}

/**
 * Haalt de ruwe data achter de datakwaliteitsscore op via de
 * `getDataQualityDetails` Cloud Function (europe-west1): welke deelnemers
 * niet gemeten zijn, welke inzendingen onvolledig, welke records fout.
 * Live berekend (memo van 2 minuten over de dimensiepagina's heen) — dit is
 * het onderzoeksinstrument achter de dimensiepagina's.
 *
 * AI-CONTEXT: See docs/features/datakwaliteitsscore.md
 *
 * @returns {{ details: object | null, loading: boolean, error: Error | null }}
 */
const useDataQualityDetails = () => {
    const [details, setDetails] = useState(/** @type {object | null} */ (null))
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(/** @type {Error | null} */ (null))

    useEffect(() => {
        let active = true
        setLoading(true)
        setError(null)

        fetchDetails()
            .then((data) => { if (active) setDetails(data) })
            .catch((err) => {
                console.error('useDataQualityDetails error:', err)
                if (active) setError(err)
            })
            .finally(() => { if (active) setLoading(false) })

        return () => { active = false }
    }, [])

    return { details, loading, error }
}

export default useDataQualityDetails
